export default {"src":"/_next/static/media/logo-black.e1649edc.svg","height":41,"width":82,"blurWidth":0,"blurHeight":0};